import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { settingsService } from '../services/api'

const Currency = ({ amount, className = '' }) => {
  const { data: settings } = useQuery({
    queryKey: ['currency-settings'],
    queryFn: () => settingsService.getSettings(),
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  })

  const currencySymbol = settings?.currency_symbol || 'KD'
  const currency = settings?.currency || 'KWD'

  const formatAmount = (value) => {
    if (!value) return '0'
    const number = parseFloat(value)
    
    // If it's a whole number, don't show decimal places
    if (number % 1 === 0) {
      return number.toString()
    }
    
    // For decimals, show up to 3 decimal places but remove trailing zeros
    const formatted = number.toFixed(3)
    return formatted.replace(/\.?0+$/, '')
  }

  return (
    <span className={className}>
      {formatAmount(amount)} {currencySymbol}
    </span>
  )
}

export default Currency
